/* global google */
import selectFirstOnEnter from './select-first-on-enter';
import { loadMaps } from './maps-loader';
import { loaderHTML } from '../../utils';

const key = SWDLocalise.googleMapsAPIKey;
const autocompleteForms = document.querySelectorAll('.js-map-search-ac');

let isLoading = false;

const disableLoader = () => {
    document.querySelectorAll('.js-map-loader').forEach((el) => el.remove());
    isLoading = false;
};

const enableLoader = () => {
    if (isLoading) return;

    [...autocompleteForms].forEach((el) => {
        el.insertAdjacentHTML('beforeend', loaderHTML);
    });

    isLoading = true;
};

const getUserLoaction = (position) => (
    new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        const method = 'GET';
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.lat},${position.lng}&key=${key}`;
        const async = true;

        // must be sent over SSL
        request.open(method, url, async);
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                if (request.status === 200) {
                    const data = JSON.parse(request.responseText);
                    const address = data.results[0];
                    resolve(address);
                } else {
                    reject(request.status);
                }
            }
        };
        request.send();
    })
);

const initGeolocate = (form, inputs) => {
    const geolocateBtn = form.querySelector('.js-map-search-ac-geolocate');
    if (navigator.geolocation) {
        geolocateBtn.addEventListener('click', () => {
            enableLoader();

            navigator.geolocation.getCurrentPosition(async (position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };

                getUserLoaction(pos).then((response) => {
                    if (response !== undefined) {
                        inputs.input.value = response.formatted_address;
                        inputs.lat.value = response.geometry.location.lat;
                        inputs.lng.value = response.geometry.location.lng;
                        form.submit();
                    }
                }).catch(console.error).finally(() => {
                    disableLoader();
                });
            }, () => {
                // permission denied / position unavailable
                disableLoader();
            });
        });
    } else {
        geolocateBtn.style.display = 'none';
    }
};

const clickHandle = (event, input) => {
    event.preventDefault();

    // select first suggestion on enter
    const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;
    if (suggestionSelected === 0) {
        input.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'ArrowDown',
            code: 'ArrowDown',
            keyCode: 40,
        }));

        input.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Enter',
            code: 'Enter',
            keyCode: 13,
        }));
    }
};

const init = () => {
    if (autocompleteForms.length === 0) return;

    let autocompleteReady = null;

    // Load the Maps JS API and attach Places Autocomplete to every search form.
    // Memoised: the API loads once and the widgets attach once, regardless of
    // how many inputs the user focuses.
    const attachAutocompletes = () => {
        if (autocompleteReady) return autocompleteReady;

        enableLoader();

        autocompleteReady = loadMaps()
            .then(() => {
                autocompleteForms.forEach((form) => {
                    const input = form.querySelector('.js-map-search-ac-input');
                    const lat = form.querySelector('.js-map-search-ac-lat');
                    const lng = form.querySelector('.js-map-search-ac-lng');

                    // init autocomplete
                    const autocomplete = new google.maps.places.Autocomplete(input, {
                        componentRestrictions: { country: 'gb' },
                    });

                    // select first suggestion on enter
                    selectFirstOnEnter(input);

                    // set the data fields to return when the user selects a place.
                    autocomplete.setFields(['address_components', 'geometry']);

                    autocomplete.addListener('place_changed', () => {
                        const place = autocomplete.getPlace();
                        if (!place.geometry) {
                            // user entered the name of a Place that was not suggested and
                            // pressed the Enter key, or the Place Details request failed.
                            console.error(`No address available for input: '${place.name}'`); // eslint-disable-line no-console
                            return;
                        }

                        lat.value = place.geometry.location.lat();
                        lng.value = place.geometry.location.lng();

                        // submit the form
                        form.submit();
                    });
                });

                disableLoader();
                return true;
            })
            .catch((error) => {
                // allow a retry on the next interaction
                autocompleteReady = null;
                disableLoader();
                console.error(error); // eslint-disable-line no-console
                return false;
            });

        return autocompleteReady;
    };

    autocompleteForms.forEach((form) => {
        const input = form.querySelector('.js-map-search-ac-input');

        // Lazy-load the Maps API on first focus — fires before the user finishes
        // typing, so the autocomplete widget is ready in time.
        input.addEventListener('focus', attachAutocompletes);

        // Search button: stop the default submit synchronously, then ensure the
        // autocomplete is ready before selecting the first suggestion.
        form.querySelector('.js-map-search-ac-btn').addEventListener('click', (event) => {
            event.preventDefault();
            attachAutocompletes().then((ready) => {
                if (ready) clickHandle(event, input);
            });
        }, false);

        // Geolocate uses navigator.geolocation + a REST Geocoding call and does
        // NOT need the Maps JS library, so it is wired up immediately. A user who
        // only geolocates never loads the Maps JS API.
        initGeolocate(form, {
            input,
            lat: form.querySelector('.js-map-search-ac-lat'),
            lng: form.querySelector('.js-map-search-ac-lng'),
        });
    });
};

export default init;
